/**
 * @fileoverview
 * Hook providing lazy access to Chat Channel i18next instance
 * loading (`translation` and `oneToOne` namespaces)
 */

import { useStore } from '@liveHelper/models/store'

import { createHook } from '@core/react-i18next-lazy'

export const useLiveHelperTranslation = createHook(
  async () => {
    const module = await import(
      /* webpackChunkName: 'i18next-oneToOne' */ './i18next'
    )
    return module.default
  },
  () => {
    return useStore((state) => state.params.lang) || 'en'
  },
  ['en-gb'],
)
